export const TEXT = {
  CTA: {id: 'account.userInfo.password_cta'},

  INPUT_ERROR_EMPTY: {id: 'account.password.emptyError'},
  INPUT_ERROR_NOT_MATCH: {id: 'account.password.notMatchError'},
  INPUT_PASSWORD: {id: 'account.password.placeholder'},
  INPUT_REPEAT_PASSWORD: {id: 'account.password.repeatPassword'},

  NOTIFICATION_SUCCESS: {id: 'account.userInfo.toast_password_success'},
};
